
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bricks",
      function () {
        return require("private-next-pages/bricks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bricks"])
      });
    }
  